import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import React, { useContext } from "react";
import styles from "./new-card-features.scss.js";
import CircleCheckmark from "components/core/circle-checkmark/circle-checkmark-component.js";
import MondayAiIcon from "components/core/monday-ai-icon/monday-ai-icon-component.js";
import { GenericConfigContext } from "contexts/generic-config-context.js";
import Label from "segments/desktop/grid/layouts/background-image-cards-grid/card-button/label/label.js";
import { TIERS } from "constants/pricing.js";
import TooltipComponent from "components/enhancements/tooltip/tooltip-component.js";
import { DARK_THEME } from "components/enhancements/tooltip/tooltip-constants.js";
const isLimitNumeric = (limit)=>{
    return !isNaN(limit);
};
const transformDescription = (description, limit, keepLowercase = false)=>{
    if (!limit && !keepLowercase) {
        return description.charAt(0).toUpperCase() + description.slice(1);
    }
    return description;
};
const NewCardFeatures = ({ tier, features, productName, isMostPopular, addon })=>{
    const { translate, localeId } = useContext(GenericConfigContext);
    const getFeatureIcon = (feature)=>{
        if (feature.isAI) {
            return /*#__PURE__*/ _jsx(MondayAiIcon, {
                disabled: feature.disabled
            });
        }
        return /*#__PURE__*/ _jsx(CircleCheckmark, {
            disabled: feature.disabled,
            highligted: isMostPopular
        });
    };
    const getSectionTitle = (featureCategory)=>{
        if (tier.name === TIERS.ENTERPRISE) {
            return featureCategory.title ? translate(featureCategory.title) : /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        style: {
                            textDecoration: 'underline'
                        },
                        children: translate("pricingPage.products.crm.features.sections.everythingInPro")
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        children: [
                            ", ",
                            translate("pricingPage.products.crm.features.sections.enterprisePlus")
                        ]
                    })
                ]
            });
        }
        return translate(featureCategory.title);
    };
    const getFeatureLimit = (limit)=>{
        if (!limit) {
            return null;
        }
        if (isLimitNumeric(limit)) {
            return parseInt(limit).toLocaleString(localeId);
        }
        return translate(limit);
    };
    const hasTranslation = (key)=>{
        const translationValue = translate(key);
        return translationValue !== key;
    };
    return /*#__PURE__*/ _jsxs("div", {
        style: {
            flex: 1
        },
        className: `jsx-${styles.__hash}`,
        children: [
            /*#__PURE__*/ _jsx(_JSXStyle, {
                id: styles.__hash,
                children: styles
            }),
            features && features.map((featureCategory, categoryIndex)=>/*#__PURE__*/ _jsxs("div", {
                    className: `jsx-${styles.__hash}` + " " + "feature-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${styles.__hash}` + " " + "feature-category-title",
                            children: getSectionTitle(featureCategory)
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: `jsx-${styles.__hash}` + " " + "features-container",
                            children: featureCategory.features.map((feature, index)=>/*#__PURE__*/ _jsx("div", {
                                    style: {
                                        marginBottom: 0
                                    },
                                    className: `jsx-${styles.__hash}` + " " + "feature",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: `jsx-${styles.__hash}` + " " + "icon",
                                        children: [
                                            hasTranslation(`pricingPage.products.${productName}.features.${feature.description}.description`) && /*#__PURE__*/ _jsx("div", {
                                                className: `jsx-${styles.__hash}` + " " + "tooltip",
                                                children: /*#__PURE__*/ _jsx(TooltipComponent, {
                                                    theme: DARK_THEME,
                                                    className: "floating-tooltip",
                                                    children: translate(`pricingPage.products.${productName}.features.${feature.description}.description`)
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: `jsx-${styles.__hash}` + " " + "feature-item",
                                                children: [
                                                    getFeatureIcon(feature),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: `jsx-${styles.__hash}`,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: `jsx-${styles.__hash}` + " " + `feature-limit feature-item-text ${feature.disabled ? 'disabled-feature' : ''}`,
                                                                children: feature.limit && getFeatureLimit(feature.limit)
                                                            }),
                                                            feature.description && /*#__PURE__*/ _jsx("span", {
                                                                className: `jsx-${styles.__hash}` + " " + `feature-item-text ${feature.disabled ? 'disabled-feature' : ''}`,
                                                                children: ' ' + transformDescription(translate(`pricingPage.products.crm.features.${feature.description}`), feature.limit, feature.keepLowercase)
                                                            }),
                                                            feature.monthIndicator && /*#__PURE__*/ _jsxs("span", {
                                                                className: `jsx-${styles.__hash}` + " " + "month-indicator",
                                                                children: [
                                                                    " /",
                                                                    translate("pricingPage.month")
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    feature.comingSoon && /*#__PURE__*/ _jsx(Label, {
                                                        marginAuto: false,
                                                        text: translate("pricingPage.soon"),
                                                        borderColor: "blue"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, index))
                        })
                    ]
                }, categoryIndex))
        ]
    });
};
export default NewCardFeatures;
